<template>
  <div class="inner t-center">
    <AmexDetailsHeader :items="icons" @change-view="select">
      <div class="last-item">
        <div class="search-drop">
          <SearchInput v-model="filterValue" />
          <Dropdown :active="filterOptions.length > 0" class="dropdown">
            <InterestDropItem
              @click="toggleTag(item)"
              :value="item.parent"
              :label="item.text"
              :tag="item"
              class="select-option"
              v-for="item in filterOptions"
              :key="item.id"
            />
          </Dropdown>
        </div>
        <!-- <button class="btn amex-primary" @click="onSubmitFilters">Let's go</button> -->
      </div>
    </AmexDetailsHeader>
    <SectionsHeader
      :availableSections="availableSections"
      :selectedCategory="activeSectionId"
      :filterSubCategory="filterSubCategory || (activeSection && activeSection.name)"
      :contextName="context"
      @section-selected="onSelectSection"
    />
    <div class="tag-cloud">
      <Tag
        :tag="tag"
        :class="{selected: isActivated(tag), 'tag-withcheckmark': isActivated(tag), darkSelection: true}"
        v-for="tag in this.tags"
        :key="tag.id"
        @click="toggleTag(tag)"
      />
    </div>
    <div class="actions" v-if="showMoreBtn">
      <BaseBtn class="show-more-btn" @click="showMore">
        <span><span>Show More</span></span>
      </BaseBtn>
    </div>
    <div class="result">
      <div class="selection" v-if="isAnySelected">
        <span>You selected:</span>
        <div class="selection-tags">
          <Tag
            :tag="tag"
            v-for="tag in firstSelectedTags"
            :key="tag.id"
            @click="toggleTag(tag)"
            class="selected tag-withcheckmark darkSelection"
          />

          <!--
          <Tag class="tag-withcheckmark extendable-tag" v-if="additionalTags.length">
            and {{ additionalTags.length }} more
            <tag-ext
              :selectedIcon="selectedIcon"
              :selectedCategory="selectedCategory"
              :additionalTags="additionalTags"
              @toggle-tag="toggleTag"
            />
          </Tag>
          -->
        </div>
      </div>
      <button class="btn amex-primary bottom-btn dialog-prferences-btn" @click="onSubmitFilters">Confirm</button>
    </div>
  </div>
</template>

<script>
import {groupFilterSections} from '@/store/state/utils';
import MarkerIcon from '@common/details-header/marker2.vue';
import FlightIcon from '@common/details-header/airplane2.vue';
import DiningIcon from '@common/details-header/dining.vue';
import StayIcon from '@common/details-header/stay.vue';
import AmexDetailsHeader from '@common/details-header/amex-details-header.vue';
import SectionsHeader from './sections-header.vue';
import Tag from '@common/filter-tag/tag.vue';
import SearchInput from './search-input';
import Dropdown from '@common/dropdown/dropdown.vue';
import InterestDropItem from './interests-filter-drop-item.vue';
import BaseBtn from '@common/button/button.vue';
import {useParams} from '@/router/router';

export const TagCategory = {
  ACCOMMODATION: 'ACCOMMODATION',
  EXPERIENCE: 'EXPERIENCE',
  DINING: 'DINING',
  TRANSPORTATION: 'TRANSPORTATION',
  // TRIPPREFERENCE: 'TRIPPREFERENCE',
};

const DomainText = {
  ACCOMMODATION: 'Stay',
  EXPERIENCE: 'Experiences',
  DINING: 'Dining',
  TRANSPORTATION: 'Flights',
};

export default {
  components: {
    AmexDetailsHeader,
    SectionsHeader,
    Tag,
    SearchInput,
    Dropdown,
    InterestDropItem,
    BaseBtn,
  },
  name: 'InterestFilter',
  props: {
    availableTags: {
      type: Array,
      default: () => [],
    },
    availableCategories: {
      type: Object,
      default: () => ({
        [TagCategory.ACCOMMODATION]: true,
        [TagCategory.DINING]: true,
        [TagCategory.EXPERIENCE]: true,
        [TagCategory.TRANSPORTATION]: true,
      }),
    },
  },
  mounted() {
    this.activatedFilters = this.availableTags.reduce((res, x) => {
      res[x.id] = x.value;
      return res;
    }, {});
    const activeCategory = Object.keys(this.availableCategories)[0];

    this.active = activeCategory;
    const tags = this.activeSection.options;
    this.tags = tags.slice(0, this.shownFilters).map((x) => ({...x, isActive: this.activatedFilters[x.id]}));

    this.$emit('selection-changed', this.getSelectedTags());
  },
  computed: {
    context() {
      const params = useParams();
      return params.value.contextName;
    },
    activeFilters() {
      return groupFilterSections(this.availableTags, this.active);
    },
    showMoreBtn() {
      return this.activeSection.options.length > this.shownFilters;
    },
    availableSections() {
      return this.activeFilters.filter((x) => x.options.length);
    },
    activeSection() {
      const active = this.activeFilters.find((x) => x.id === this.activeFilterSection);
      const first = this.activeFilters.find((x) => Boolean(x));
      if (!active) {
        return first;
      }
      return active;
    },
    activeSectionId() {
      return this.activeSection ? this.activeSection.id : '';
    },
    allFilterTags() {
      const tags = (this.activeSection ? this.activeSection.options : []) || [];
      return tags;
    },
    isAnySelected() {
      return this.availableTags
        .filter((x) => x.domain === this.active || (this.active === 'EXPERIENCE' && x.domain === 'TRIPPREFERENCE'))
        .some((x) => this.activatedFilters[x.id]);
    },
    firstSelectedTags() {
      return this.availableTags
        .filter((x) => this.activatedFilters[x.id])
        .filter((x) => x.domain === this.active || (this.active === 'EXPERIENCE' && x.domain === 'TRIPPREFERENCE'))
        .sort((a, b) => this.sortTags(a, b));
      //        .slice(0, 3);
    },
    additionalTags() {
      return this.availableTags
        .filter((x) => this.activatedFilters[x.id])
        .filter((x) => x.domain === this.active || (this.active === 'EXPERIENCE' && x.domain === 'TRIPPREFERENCE'))
        .sort((a, b) => this.sortTags(a, b))
        .slice(3);
    },
    filterOptions() {
      const tags = this.availableTags || [];
      return this.filterValue
        ? tags
            .filter((x) => x.name.toLowerCase().includes(this.filterValue.toLowerCase()))
            .map((x) => ({...x, text: DomainText[x.domain]}))
            .slice(0, 2)
        : [];
    },
    selectedIcon() {
      const icon = this.icons.find((x) => x.id === this.active);
      return icon ? icon.icon : StayIcon;
    },
    selectedCategory() {
      const icon = this.icons.find((x) => x.id === this.active);
      return icon ? icon.name : 'Stays';
    },
    icons() {
      // @ts-ignore
      const vm = this;
      return [
        {
          id: TagCategory.ACCOMMODATION,
          name: 'Stay',
          get active() {
            return vm.active === TagCategory.ACCOMMODATION;
          },
          get counter() {
            return vm.getCategoryNumbers(TagCategory.ACCOMMODATION);
          },
          completed: false,
          icon: StayIcon,
        },
        {
          id: TagCategory.DINING,
          name: 'Dining',
          get active() {
            return vm.active === TagCategory.DINING;
          },
          get counter() {
            return vm.getCategoryNumbers(TagCategory.DINING);
          },
          completed: false,
          icon: DiningIcon,
        },
        {
          id: TagCategory.EXPERIENCE,
          name: 'Experiences',
          get active() {
            return vm.active === TagCategory.EXPERIENCE;
          },
          get counter() {
            return vm.getCategoryNumbers(TagCategory.EXPERIENCE);
          },
          completed: false,
          icon: MarkerIcon,
        },
        {
          id: TagCategory.TRANSPORTATION,
          name: 'Flights',
          get active() {
            return vm.active === TagCategory.TRANSPORTATION;
          },
          get counter() {
            return vm.getCategoryNumbers(TagCategory.TRANSPORTATION);
          },
          completed: false,
          icon: FlightIcon,
        },
      ];
    },
  },
  methods: {
    showMore() {
      this.shownFilters += 30;
      const tags = this.activeSection.options;
      this.tags = tags.slice(0, this.shownFilters).map((x) => ({...x, isActive: this.activatedFilters[x.id]}));
    },
    isActivated(tag) {
      return this.activatedFilters[tag.id];
    },
    sortTags(a, b) {
      if (!this.lastTags[b.id] || !this.lastTags[a.id]) {
        return -1;
      }
      return this.lastTags[b.id] - this.lastTags[a.id];
    },
    getCategoryNumbers(category) {
      return this.availableTags.filter((x) => x.domain === category && this.activatedFilters[x.id]).length;
    },
    toggleTag(value) {
      this.activatedFilters[value.id] = !this.activatedFilters[value.id];
      if (this.activatedFilters[value.id]) {
        this.lastTags[value.id] = this.numberOfSelectedTags++;
      }
      this.activatedFilters = {...this.activatedFilters};
      this.$emit('selection-changed', this.getSelectedTags());
      this.filterValue = '';
    },
    onSelectSection(section) {
      if (this.activeFilterSection !== section.id) {
        this.shownFilters = 30;
      }
      this.filterSubCategory = section.name;
      this.activeFilterSection = section.id;
      const tags = section.options;
      this.tags = tags.slice(0, this.shownFilters).map((x) => ({...x, isActive: this.activatedFilters[x.id]}));
    },
    select(item) {
      this.active = item.id;
      const tags = this.activeSection.options;
      this.tags = tags.map((x) => ({...x, isActive: this.activatedFilters[x.id]}));

      this.$emit('selection-changed', this.getSelectedTags());
    },
    getSelectedTags() {
      return this.availableTags
        .filter((x) => this.activatedFilters[x.id])
        .map((x) => {
          return {
            ...x,
            value: true,
          };
        });
    },
    onSubmitFilters() {
      this.$emit('submit-active-filters', this.getSelectedTags());
    },
  },
  data() {
    return {
      activatedFilters: {},
      filterValue: '',
      activeFilterSection: '',
      activeFilterSubCategory: '',
      filterSubCategory: '',
      active: TagCategory.ACCOMMODATION,
      lastTags: {},
      numberOfSelectedTags: 0,
      shownFilters: 30,
      tags: [],
    };
  },
};
</script>

<style scoped>
.tag-cloud {
  padding: 20px 0 0 0;
  position: relative;
}

.result {
  display: flex;
  justify-content: space-between;
  padding: 16px 0;
  border-top: 1px solid #e6e6e6;
  margin-top: 30px;
}

.btn {
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
}

.bottom-btn {
  margin-left: auto;
}

.btn.amex-primary {
  background: var(--btn-primary-bg, hsl(214, 64%, 48%));
  border-radius: 10px;
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 118.14%;
  /* or 21px */

  text-align: center;
  letter-spacing: -0.005em;

  color: #ffffff;
  padding: 12px 100px 10px;
}

.btn.amex-primary:hover {
  background: var(--btn-primary-bg-active, hsl(214, 64%, 30%));
}

.selection {
  display: flex;
}

.selection > span {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  /* or 14px */

  letter-spacing: -0.005em;

  color: rgba(7, 29, 59, 0.4);
  margin-right: 10px;
  display: flex;
  align-items: center;
}

.selection-tags .tag-withcheckmark {
  padding: 8px 10px 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
}

.tag-withcheckmark {
  background-color: #071d3b !important;
  color: #ffffff;
}

/* .selection-tags .tag-withcheckmark::before {
  content: '';
  position: absolute;
  top: 2px;
  right: 3px;
  margin: -8px -8px 0 0;
  opacity: 1;
  transform: none;
  width: 12px;
  height: 12px;
  border-radius: 14px;
  background-color: #a3abb6;
  border: 2px solid #fff;
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='5' viewBox='0 0 6 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M5.3215 0.617066C5.53299 0.794617 5.56051 1.11 5.38296 1.3215L2.86444 4.3215C2.76944 4.43466 2.62925 4.50001 2.48149 4.50001C2.33374 4.50001 2.19355 4.43466 2.09855 4.3215L0.617066 2.55679C0.439515 2.3453 0.467031 2.02991 0.678526 1.85236C0.890021 1.67481 1.20541 1.70233 1.38296 1.91382L2.48149 3.22237L4.61707 0.678526C4.79462 0.467031 5.11 0.439515 5.3215 0.617066Z' fill='white'/%3E%3C/svg%3E%0A");
  background-size: 7px;
  background-position: 1px 1px;
  background-repeat: no-repeat;
} */

.extendable-tag {
  position: relative;
}

.extendable-tag:hover > * {
  opacity: 1;
  pointer-events: auto;
}

.last-item {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
}

.dropdown {
  position: absolute;
  width: auto;
  max-width: min-content;
  min-width: 300px;
  right: 0;
  left: auto;
  height: auto;
}

.search-drop {
  position: relative;
  margin-right: 10px;
}

.show-more-btn {
  font-size: 16px;
  position: relative;
  border: 0;
  appearance: none;
  background-color: transparent;
  color: #a3abb6;
  line-height: 30px;
  height: 26px;
  width: 100%;
}

.show-more-btn > span {
  display: flex;
}

.show-more-btn > span::before,
.show-more-btn > span::after {
  content: '';
  top: 14px;
  position: relative;
  flex: 1;
  width: 100%;
  height: 1px;
  background-color: #a3abb6;
  flex: 1;
}
.show-more-btn > span::before {
  margin-right: 30px;
}
.show-more-btn > span::after {
  margin-left: 30px;
}

.show-more-btn > span > span::after {
  content: '';
  top: 0;
  position: absolute;
  width: 16px;
  height: 100%;
  background-image: url(./icon-filter-downarrow.svg);
  background-size: 8px;
  background-position: center right;
  background-repeat: no-repeat;
  opacity: 0.5;
  transition: transform 0.2s linear;
  transform-origin: 75% center;
  will-change: transform;
}

.show-more-btn.active > span > span::after {
  transform: rotate(60deg);
}
.dialog-prferences-btn {
  height: 43px;
}
</style>
